export default __webpack_public_path__ + "static/media/bg2.98f36493.jpg";